import { takeLatest, call, put } from "redux-saga/effects";
import {
  GET_AZURE,
  GET_AZURE_SUCCESS,
  GET_AZURE_ERROR,
  SESSION_SUCCESS,
  SESSION_ERROR,
  SESSION,
} from "./constant";

import { getAzureApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureList(params) {
  try {
    const data = yield call(getAzureApi, params);
    yield put({ type: GET_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_ERROR, error });
  }
}

/**
 * action Type of getSessioninfo
 * @param {Object} action
 */
function* setSessioninfo(params) {
  try {
    let data = params.params;
    yield put({ type: SESSION_SUCCESS, data });
  } catch (error) {
    yield put({ type: SESSION_ERROR, error });
  }
}
/**
 * Get Login Saga
 */
export function* manageAzureSaga() {
  yield takeLatest(GET_AZURE, getAzureList);
  yield takeLatest(SESSION, setSessioninfo);
}
